import { render, staticRenderFns } from "./dialog-statistics.vue?vue&type=template&id=2f9ec062"
import script from "./dialog-statistics.vue?vue&type=script&lang=js"
export * from "./dialog-statistics.vue?vue&type=script&lang=js"
import style0 from "./dialog-statistics.vue?vue&type=style&index=0&id=2f9ec062&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports